<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="
            border-radius: 5px !important;
            padding-left: 0px;
            height: auto !important;
          "
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Assignment Report Details</b-navbar-brand>

          <b-navbar-nav class="ml-auto"> </b-navbar-nav>
        </b-navbar>

        <b-card>
          <span class="error">Only 1 Month Data Filter Apply in Date Field</span>
          <b-row>
            <b-col md="4">
              <date-range-picker
                :opens="openRight"
                :always-show-calendars="showCal"
                v-model="dateRange"
                :startDate="startDate"
                :endDate="endDate"
                :locale-data="locale"
                class="mt-2"
              >
              </date-range-picker>
            </b-col>
            <b-col md="4">
              <b-form-input
                :formatter="capitalizeAll"
                class="mt-2"
                v-model="assignmentFilter"
                placeholder=" Assignment No."
              ></b-form-input>
            </b-col>
            <b-col md="4">
              <model-list-select
                class="mt-2"
                :list="clientMaster"
                id="clientNamenew"
                v-model="clientIdFilter"
                option-value="clientId"
                option-text="clientName"
                @input="ClientDrag"
                placeholder="Select  Client Name"
              ></model-list-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <model-list-select
                class="mt-2"
                :list="jobList"
                v-model="jobTypeFilter"
                option-value="jv"
                option-text="jt"
                placeholder=" JobType"
              ></model-list-select>
            </b-col>
            <b-col md="4">
              <model-list-select
                class="mt-2"
                @input="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                :list="finalAllPlaceDataPOR"
                v-model="PORfilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Select Place of Receipt"
              >
              </model-list-select>
            </b-col>
            <b-col md="4">
              <model-list-select
                class="mt-2"
                @input="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                :list="finalAllPlaceDataPOD"
                v-model="PODfilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Select Port of Discharge"
              ></model-list-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <model-list-select
                class="mt-2"
                @input="getLocationList($event, 'All', 'finalAllPlaceDataLP')"
                @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataLP')"
                :list="finalAllPlaceDataLP"
                v-model="LPfilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Select Load Port"
              ></model-list-select>
            </b-col>
            <b-col md="4">
              <model-list-select
                class="mt-2"
                :list="shippingList"
                v-model="shippingFilter"
                option-value="shippingId"
                option-text="shippingLine"
                placeholder="Select Shipping Line"
              ></model-list-select>
            </b-col>
            <b-col md="4">
              <model-list-select
                class="mt-2"
                :list="branchList"
                v-model="branchfilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder=" Branch"
              ></model-list-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <model-list-select
                class="mt-2"
                :list="SOBStatusList"
                v-model="SOBFilter"
                option-value="inv"
                option-text="int"
                placeholder="Select SOB Status"
              ></model-list-select>
            </b-col>
            <b-col md="4">
              <b-form-input
                :formatter="capitalizeAll"
                class="mt-2"
                v-model="containerNoFilter"
                placeholder=" Container No."
              ></b-form-input>
            </b-col>
            <b-col md="4" class="mt-2" center>
              <b-button size="sm" @click="filterSearch" variant="outline-primary"
                >Search</b-button
              >

              <b-button size="sm" class="ml-3" @click="clearFilter" variant="outline-info"
                >clear</b-button
              >
              <!-- <b-button
                size="sm"
                class="ml-3"
                @click="getReportsAss('MainAssignment_SCREEN')"
                variant="outline-info"
                >Export as Excel</b-button
              > -->
              <!-- <b-button variant="outline-primary" @click="addEditCardFunc()" size="sm"
                >Export As Excel</b-button
              > -->
              <b-button
                  :disabled="ExcelBtnName != 'Download Excel' ? true : false"
                  @click="getReportsAss('MainAssignment_SCREEN')"
                  size="sm"
                  variant="outline-info"
                >
                  {{ ExcelBtnName }}
                  <b-spinner
                    v-if="ExcelBtnName != 'Download Excel'"
                    small
                    label="Small Spinner"
                  ></b-spinner
                ></b-button>
              <b-button
                v-if="clientData"
                style="font-size: 0.675rem"
                size="sm"
                variant="primary"
                @click="goToDrag(clientData)"
                >Clients Excell Temp</b-button
              >
            </b-col>
          </b-row>
        </b-card>

        <b-card class="mt-4" v-if="addEditCard">
          <b-row>
            <b-col md="2">
              <h5>Excel Column</h5>
            </b-col>
            <b-col md="10">
              <div class="checkbox-container">
                <input
                  id="SelectAll"
                  type="checkbox"
                  class="styled-checkbox"
                  @click="selectAll()"
                  v-model="isCheckAll"
                />
                <label
                  >Select / Deselect All Count({{ this.selectedItems.length }})</label
                >
              </div>
            </b-col>
          </b-row>
          <b-row v-if="ExcelItems.length > 0">
            <b-col md="2" v-for="(item, index) in ExcelItems" :key="index">
              <div class="checkbox-container">
                <input
                  :key="index"
                  type="checkbox"
                  v-model="selectedItems"
                  :value="item.id"
                  class="styled-checkbox"
                  @click="select"
                />
                <label>{{ item.name }}</label>
              </div>
            </b-col>
          </b-row>

          <!-- <div>
            <b-row>
              <b-col md="6">
                <div class="column-section">
                  <h2>Available Columns</h2>
                  <div
                    class="draggable"
                    v-for="(item, index) in availableColumns"
                    :key="index"
                    :draggable="true"
                    @dragstart="onDragStart(item.name, 'available')"
                    @dragover.prevent
                  >
                    {{ item.name }}
                  </div>
                </div>
              </b-col>
              <b-col md="6">
                <div class="column-section">
                  <h2>Selected Columns</h2>
                  <div
                    class="draggable"
                    v-for="(item, index) in selectedColumns"
                    :key="index"
                    :draggable="true"
                    @dragstart="onDragStart(item.name, 'selected')"
                    @dragover.prevent
                  >
                    {{ item.name }}
                  </div>
                </div>
              </b-col>
            </b-row>
          </div> -->
          <b-row>
            <b-col md="12" class="mt-2">
              <div class="text-center ml-auto mr-auto">
                <!-- <b-button
                  :disabled="ExcelBtnName != 'Download Excel' ? true : false"
                  @click="getReportsAss('MainAssignment_SCREEN')"
                  size="sm"
                  variant="outline-info"
                >
                  {{ ExcelBtnName }}
                  <b-spinner
                    v-if="ExcelBtnName != 'Download Excel'"
                    small
                    label="Small Spinner"
                  ></b-spinner
                ></b-button> -->
              </div>
            </b-col>
          </b-row>
        </b-card>

        <div class="box">
          <div>
            <b-pagination
              class="mt-3"
              limit="5"
              style="margin: 0px"
              align="right"
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalRows"
              @change="onPageChange($event)"
            ></b-pagination>
          </div>
          <h5 class="text-muted pull-right mt-2 ml-3">
            <small v-if="isLoading == false">{{ totalRows }} Entries</small>
          </h5>
          <div class="table-responsive tableMain gutr">
            <b-table
              show-empty
              stacked="md"
              :items="consoBooking"
              :fields="fields"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
            >
              <template slot="jobType" slot-scope="row0">
                <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
              </template>
              <template slot="mainSalesSeries" slot-scope="row1">
                <md-icon>{{
                  row1.item.shipmentType == "1" ||
                  row1.item.shipmentType == "Sea_Shipment"
                    ? "directions_boat"
                    : "flight_takeoff"
                }}</md-icon>
                <b>{{ row1.item.mainSalesSeries }}</b>
                <br />
                <span>
                  {{ row1.item.jobType }} ({{
                    row1.item.shipmentType == "1" ||
                    row1.item.shipmentType == "Sea_Shipment"
                      ? "Sea"
                      : "Air"
                  }}
                  {{ row1.item.transportType }})</span
                >
                <br />
                <span>Assignment Dt. : {{ row1.item.assignmentDate | moment }}</span>
                <br />
                <span>Raised From : {{ row1.item.raisedFrom }}<br /></span>
                <span> By : {{ row1.item.raisedBy }}</span> <br />
                <span v-if="row1.item.sob_date != '' && row1.item.sob_date != null"
                  ><b :style="'color:black'">SOB : {{ row1.item.sob_date }}</b>
                  <b-badge variant="danger"><b>SAILED</b></b-badge></span
                >
                <br />
                <b-button
                  class="mt-2"
                  style="font-size: 0.675rem"
                  size="sm"
                  @click="showDocModal(row1.item)"
                  variant="outline-info"
                  >Summary & Documents</b-button
                >
                <br />
                <Assignment-Summary
                  :title="'Shipment Summary Tracking - '"
                  :fk_all_module_id="row1.item.allModuleId"
                  :jb_series="row1.item.mainSalesSeries"
                />

                <h7 class="mt-2" v-if="row1.item.splitFromId != '0'"
                  ><b-badge variant="info">Split of {{ row1.item.splitFromNo }}</b-badge>
                </h7>
              </template>
              <template slot="TPTClient" slot-scope="row11">
                <b
                  v-if="
                    row11.item.clientType == '3' && row11.item.transportType == 'Export'
                  "
                >
                  Client Name : {{ row11.item.exporter }}
                  <br />
                </b>

                <b v-if="row11.item.clientType == '3'">
                  Overseas Agent : {{ row11.item.TPTClient }}
                  <br />
                </b>
                <b v-if="row11.item.clientType != '3'">
                  {{ row11.item.TPTClient }}
                  <br />
                </b>
              </template>
              <!-- <template slot="ffInvoiceClosed" slot-scope="row2">
                <span v-if="row2.item.jobType.split(',').includes('FF')"
                  >FF :-
                  {{
                    row2.item.ffInvoiceClosed == "1"
                      ? "Received"
                      : "Not-Received"
                  }}<br
                /></span>
                <span v-if="row2.item.jobType.split(',').includes('CC')"
                  >CC :-
                  {{
                    row2.item.ccInvoiceClosed == "1"
                      ? "Received"
                      : "Not-Received"
                  }}<br
                /></span>
                <span v-if="row2.item.jobType.split(',').includes('TPT')"
                  >TPT :-
                  {{
                    row2.item.tptInvoiceClosed == "1"
                      ? "Received"
                      : "Not-Received"
                  }}</span
                >
              </template> -->

              <template slot="containerNo" slot-scope="row15">
                <div v-if="row15.item.containerNo">
                  <h6>
                    <b-badge variant="light"
                      >{{ row15.item.containerNo + " / " + row15.item.containerType }}
                    </b-badge>
                  </h6>
                  <!-- <span
                    v-for="(item1, index) in row15.item.containerNo.split(',')"
                    :key="index"
                    ><h6>
                      <b-badge variant="light"
                        >{{ item1 == "" ? "-------" : item1 }}
                      </b-badge>
                    </h6></span
                  > -->
                </div>
                <span v-else>-----------</span>
              </template>
              <template slot="TEUS" slot-scope="row151">
                <h6 v-if="row151.item.TEUS_Type">
                  <b-badge variant="light">{{ row151.item.TEUS_Type }} </b-badge>
                </h6>
              </template>
              <template slot="shipperInv" slot-scope="row150">
                <div v-if="row150.item.shipperInv">
                  <span
                    v-for="(item2, index) in row150.item.shipperInv.split(',')"
                    :key="index"
                    ><h6>
                      <b-badge variant="light"
                        >{{ item2 == "" ? "-------" : item2 }}
                      </b-badge>
                    </h6></span
                  >
                </div>
                <span v-else>-----------</span>
              </template>
              <template slot="ShippingB" slot-scope="row100">
                <div v-if="row100.item.ShippingB">
                  <span
                    v-for="(item3, index) in row100.item.ShippingB.split(',')"
                    :key="index"
                    ><h6>
                      <b-badge variant="light"
                        >{{ item3 == "" ? "-------" : item3 }}
                      </b-badge>
                    </h6></span
                  >
                </div>
                <span v-else>-----------</span>
              </template>
              <template slot="billingSeries" slot-scope="row1000">
                <div v-if="row1000.item.billingSeries">
                  <span
                    v-for="(item3, index) in row1000.item.billingSeries.split(',')"
                    :key="index"
                    ><h6>
                      <b-badge variant="light"
                        >{{ item3 == "" ? "-------" : item3 }}
                      </b-badge>
                    </h6></span
                  >
                </div>
                <span v-else>-----------</span>
                <Add-Message
                  :fk_all_module_id="row1000.item.allModuleId"
                  style="list-style-type: none"
                />
              </template>
            </b-table>
          </div>
        </div>

        <div>
          <b-pagination
            limit="25"
            align="center"
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
            @change="onPageChange($event)"
          ></b-pagination>
        </div>
      </b-card-text>
    </b-card>
    <div>
      <b-modal
        class="modal-dialog-doc"
        size="xl"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        title=""
      >
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  lastVisitPage,
} from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import DocForm from "./docLibrary.vue";
import AddMessage from "../../component/allModuleForm/addMessage.vue";
import AssignmentSummary from "../../component/common/assignmentSummary.vue";
import CommonService from "../../services/CommonService.js";

export default {
  beforeMount() {
    this.getCurrentLastDate();
    lastVisitPage(this.$router.history.current.fullPath);
    this.$store.dispatch("setCurrentRoute", "/mainReport");
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != "" &&
      this.$sessionsStorage.get("departmentName") != undefined &&
      this.$sessionsStorage.get("departmentName") != "" &&
      this.$sessionsStorage.get("designation") != undefined &&
      this.$sessionsStorage.get("designation") != ""
    ) {
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewFFExportFCL("0", "1", "1");
      }
    } else {
      this.$sessionsStorage.set("loginId", "");
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      ExcelBtnName: "Download Excel",
      docURL: URL_BASE_DOC,
      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      closingReason: "",
      eventId: "",
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      openRight: "right",
      showCal: false,
      showDash: false,

      // date: ['2018-06-01'],
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      branchList: [],
      totalRows: 1000000000000000,
      currentPage: 1,
      perPage: 50,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      fields: [
        {
          key: "jobType",
          mainkey: "jobType",
          label: "#",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "mainSalesSeries",
          mainkey: "mainSalesSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "TPTClient",
          mainkey: "clientName",
          label: "Client / Shipper Name",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "containerNo",
          mainkey: "containerNo",
          label: "Container No./Type",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },

        {
          key: "TEUS",
          mainkey: "TEUS",
          label: "TEUS",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "shipperInv",
          mainkey: "shipperInv",
          label: "Shipper Inv",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "ShippingB",
          mainkey: "ShippingB",
          label: "Shipping Bill",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },

        // {
        //   key: "ffInvoiceClosed",
        //   mainkey: "ffInvoiceClosed",
        //   label: "Execution Invoice",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "Z.",
        // },
        {
          key: "billingSeries",
          mainkey: "billingSeries",
          label: "Inv No.Added to Tally ",
          sortable: true,
          sortDirection: "ASC",
          //  table: "B."
        },
        // {
        //   key: "mainEnquiryId",
        //   mainkey: "mainEnquiryId",
        //   label: "Billing",
        //   sortable: true,
        //   sortDirection: "ASC",
        // },
      ],

      mailallModuleId: "",
      mailExecSeries: "",
      incompleteJobBill: "",
      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      clientIdFilter: "",
      assignmentFilter: "",
      ContainerFilter: "",
      shiperInvFilter: "",
      InvoiceNoFilter: "",
      SBFilter: "",
      selectedAllModuleId: "",
      jobTypeFilter: "",
      statusFilter: "0",
      branchfilter: "",
      jobRecFilter: [],
      consoBooking: [],
      clientMaster: [],
      finalAllPlaceDataPOR: [],
      finalAllPlaceDataPOD: [],
      finalAllPlaceDataLP: [],
      shippingList: [],
      shippingFilter: "",
      PORfilter: "",
      PODfilter: "",
      LPfilter: "",
      reload: true,
      jobRecList: [
        { value: "0", text: "TPT Received" },
        { value: "1", text: "CC Received" },
        { value: "2", text: "FF Received" },
      ],

      jobList: [
        {
          jv: "FF",
          jt: "FF",
        },
        {
          jv: "CC",
          jt: "CC",
        },
        {
          jv: "TPT",
          jt: "TPT",
        },
      ],
      invoiceStatusList: [
        {
          inv: "0",
          int: "Pending",
        },
        {
          inv: "1",
          int: "Completed",
        },
        {
          inv: "2",
          int: "All",
        },
        {
          inv: "3",
          int: "No-Billing",
        },
      ],
      SOBFilter: "3",
      containerNoFilter: "",
      SOBStatusList: [
        {
          inv: "1",
          int: "Sailed",
        },
        {
          inv: "2",
          int: "Not Sailed",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
      ExcelItems: [
        { id: "Assignment No", name: "Assignment No" },
        { id: "Assignment Date", name: "Assignment Date" },
        { id: "Job Type", name: "Job Type" },
        { id: "Raised From", name: "Raised From" },
        { id: "Raised By", name: "Raised By" },
        { id: "Client Name", name: "Client Name" },
        { id: "Container No", name: "Container No" },
        { id: "Container Type", name: "Container Type" },
        { id: "TEUS", name: "TEUS" },
        { id: "Container Split Remark", name: "Container Split Remark" },
        { id: "Shipping Line", name: "Shipping Line" },
        { id: "Invoice No.", name: "Invoice No." },
        { id: "Measurement", name: "Measurement" },
        { id: "Custom Seal No", name: "Custom Seal No" },
        { id: "Line Seal No", name: "Line Seal No" },
        { id: "Shipper Inv", name: "Shipper Inv" },
        { id: "Shipper Inv Date", name: "Shipper Inv Date" },
        { id: "Shipping Bill No", name: "Shipping Bill No" },
        { id: "Shipping Bill Date", name: "Shipping Bill Date" },
        { id: "GRN No.", name: "GRN No." },
        { id: "Transportation By", name: "Transportation By" },
        { id: "Vehicle No.", name: "Vehicle No." },
        {
          id: "Dispatch date (Departed from ICD).",
          name: "Dispatch date (Departed from ICD).",
        },
        { id: "Stuffing / De-stuffing Date.", name: "Stuffing / De-stuffing Date." },
        { id: "Arrival at Factory", name: "Arrival at Factory" },
        { id: "Dispatch from Factory", name: "Dispatch from Factory" },
        { id: "Arrival at Port / ICD", name: "Arrival at Port / ICD" },
        { id: "Vehicle Release Date", name: "Vehicle Release Date" },
        { id: "Sales Booking No", name: "Sales Booking No" },
        { id: "Freight Container Type", name: "Freight Container Type" },
        { id: "Stuffing Type", name: "Stuffing Type" },
        { id: "Destination Delivery Mode", name: "Destination Delivery Mode" },
        { id: "Vessel/voyage", name: "Vessel/voyage" },
        { id: "VGM Submission Date", name: "VGM Submission Date" },
        { id: "SI Submission Date", name: "SI Submission Date" },
        { id: "Freight Term for HBL", name: "Freight Term for HBL" },
        { id: "Freight Term for MBL", name: "Freight Term for MBL" },
        { id: "B/L type", name: "B/L type" },
        { id: "Leo Date", name: "Leo Date" },
        { id: "Handover Date", name: "Handover Date" },
        { id: "TR Submission Date", name: "TR Submission Date" },
        { id: "TR Submission Mode", name: "TR Submission Mode" },
        { id: "Train No", name: "Train No" },
        { id: "Wagon No", name: "Wagon No" },
        { id: "Train Departure Date and Time", name: "Train Departure Date and Time" },
        { id: "Train Arival Date and Time", name: "Train Arival Date and Time" },
        { id: "Shipment Booking No", name: "Shipment Booking No" },
        { id: "MBL No.", name: "MBL No." },
        { id: "HBL No", name: "HBL No" },
        { id: "POR Location", name: "POR Location" },
        { id: "LP Location", name: "LP Location" },
        { id: "POD Location", name: "POD Location" },
        { id: "Final place location", name: "Final place location" },
        { id: "Debit Note no.", name: "Debit Note no." },
        { id: "Credit Note No.", name: "Credit Note No." },
        { id: "SOB Date", name: "SOB Date" },
        { id: "ETA Destination Estimated", name: "ETA Destination Estimated" },
        { id: "ETA Destination Actual", name: "ETA Destination Actual" },
      ],
      // availableColumns: [
      //   { "id": "Assignment No", "name": "Assignment No" },
      //   { "id": "Assignment Date", "name": "Assignment Date" },
      //   { "id": "Job Type", "name": "Job Type" },
      //   { "id": "Raised From", "name": "Raised From" },
      //   { "id": "Raised By", "name": "Raised By" },
      //   { "id": "Client Name", "name": "Client Name" },
      //   { "id": "Container No", "name": "Container No" },
      //   { "id": "Container Type", "name": "Container Type" },
      //   { "id": "TEUS", "name": "TEUS" },
      //   { "id": "Container Split Remark", "name": "Container Split Remark" },
      //   { "id": "Shipping Line", "name": "Shipping Line" },
      //   { "id": "Invoice No.", "name": "Invoice No." },
      //   { "id": "Measurement", "name": "Measurement" },
      //   { "id": "Custom Seal No", "name": "Custom Seal No" },
      //   { "id": "Line Seal No", "name": "Line Seal No" },
      //   { "id": "Shipper Inv", "name": "Shipper Inv" },
      //   { "id": "Shipper Inv Date", "name": "Shipper Inv Date" },
      //   { "id": "Shipping Bill No", "name": "Shipping Bill No" },
      //   { "id": "Shipping Bill Date", "name": "Shipping Bill Date" },
      //   { "id": "GRN No.", "name": "GRN No." },
      //   { "id": "Transportation By", "name": "Transportation By" },
      //   { "id": "Vehicle No.", "name": "Vehicle No." },
      //   { "id": "Dispatch date (Departed from ICD).", "name": "Dispatch date (Departed from ICD)." },
      //   { "id": "Stuffing / De-stuffing Date.", "name": "Stuffing / De-stuffing Date." },
      //   { "id": "Arrival at Factory", "name": "Arrival at Factory" },
      //   { "id": "Dispatch from Factory", "name": "Dispatch from Factory" },
      //   { "id": "Arrival at Port / ICD", "name": "Arrival at Port / ICD" },
      //   { "id": "Vehicle Release Date", "name": "Vehicle Release Date" },
      //   { "id": "Sales Booking No", "name": "Sales Booking No" },
      //   { "id": "Freight Container Type", "name": "Freight Container Type" },
      //   { "id": "Stuffing Type", "name": "Stuffing Type" },
      //   { "id": "Destination Delivery Mode", "name": "Destination Delivery Mode" },
      //   { "id": "Vessel/voyage", "name": "Vessel/voyage" },
      //   { "id": "VGM Submission Date", "name": "VGM Submission Date" },
      //   { "id": "SI Submission Date", "name": "SI Submission Date" },
      //   { "id": "Freight Term for HBL", "name": "Freight Term for HBL" },
      //   { "id": "Freight Term for MBL", "name": "Freight Term for MBL" },
      //   { "id": "B/L type", "name": "B/L type" },
      //   { "id": "Leo Date", "name": "Leo Date" },
      //   { "id": "Handover Date", "name": "Handover Date" },
      //   { "id": "TR Submission Date", "name": "TR Submission Date" },
      //   { "id": "TR Submission Mode", "name": "TR Submission Mode" },
      //   { "id": "Train No", "name": "Train No" },
      //   { "id": "Wagon No", "name": "Wagon No" },
      //   { "id": "Train Departure Date and Time", "name": "Train Departure Date and Time" },
      //   { "id": "Train Arival Date and Time", "name": "Train Arival Date and Time" },
      //   { "id": "Shipment Booking No", "name": "Shipment Booking No" },
      //   { "id": "MBL No.", "name": "MBL No." },
      //   { "id": "HBL No", "name": "HBL No" },
      //   { "id": "POR Location", "name": "POR Location" },
      //   { "id": "LP Location", "name": "LP Location" },
      //   { "id": "POD Location", "name": "POD Location" },
      //   { "id": "Final place location", "name": "Final place location" },
      //   { "id": "Debit Note no.", "name": "Debit Note no." },
      //   { "id": "Credit Note No.", "name": "Credit Note No." },
      //   { "id": "SOB Date", "name": "SOB Date" },
      //   { "id": "ETA Destination Estimated", "name": "ETA Destination Estimated" },
      //   { "id": "ETA Destination Actual", "name": "ETA Destination Actual" }
      // ],
      isCheckAll: false,
      SelectExcelName: [],
      selectedItems: [],
      addEditCard: false,
      //Drag and Drop
      // dragIndex: null,
      // dragSection: null,
      // selectedColumns: [],
      clientData: null,
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
    DocForm,
    AddMessage,
    AssignmentSummary,
  },

  computed: {},
  watch: {
    clientIdFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    shiperInvFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    SBFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    ContainerFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    jobTypeFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    branchfilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    assignmentFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    InvoiceNoFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
  },
  methods: {
    ClientDrag() {
      this.clientData = null;
      if (this.clientIdFilter) {
        let array = this.clientMaster.filter((x) => {
          return x.clientId == this.clientIdFilter;
        });
        this.clientData = array.length > 0 ? array[0] : null;
      }
      console.log("PS CleintData=>", this.clientData);
    },

    goToDrag(items) {
      this.$sessionsStorage.set("editClientId", "");
      this.$sessionsStorage.set("editClientName", "");
      this.$sessionsStorage.set("editClientExcelTemplate", "");
      this.$sessionsStorage.set("editClientId", items.clientId);
      this.$sessionsStorage.set("editClientName", items.clientName);
      this.$sessionsStorage.set("editClientExcelTemplate", "");

      this.$router.push({
        path: "/drag_drop",
      });
    },
    addEditCardFunc() {
      this.addEditCard = !this.addEditCard;
    },
    selectAll: function () {
      this.selectedItems = [];
      this.SelectExcelName = [];
      this.isCheckAll = !this.isCheckAll;

      if (this.isCheckAll) {
        for (var item in this.ExcelItems) {
          this.selectedItems.push(this.ExcelItems[item].name);
          this.SelectExcelName.push(this.ExcelItems[item].name);
        }
      } else {
        this.selectedItems = [];
        this.SelectExcelName = [];
      }
    },
    select: function () {
      if (this.SelectExcelName.length == this.ExcelItems.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }
    },

    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.mainSalesSeries;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      // alert(firstDay);
      // alert(lastDay);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      //  alert(firstDay);
      // alert(lastDay);

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      // alert(today);
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };

      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    validateBilling(id, jobType) {
      this.selectedAllModuleId = id;
      this.isLoading = true;

      let payload = {
        allModuleId: id,
        job: jobType,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/validateCloseBilling.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.incompleteJobBill.length > 0) {
              this.incompleteJobBill = data.incompleteJobBill.toString();
            }
            this.$refs["modal-close-conf"].show();
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },

    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    getReportsAss(id) {
      let excelIdGivin = "";

      if (id == "MainAssignment_SCREEN") {
        excelIdGivin = "MainAssignment_SCREEN";
      } else if (id == "MainAssignment_SCREEN_ALL") {
        excelIdGivin = "MainAssignment_SCREEN_ALL";
      }
      let view_Assignment = {
        excelId: excelIdGivin,
        clientIdFilter: this.clientIdFilter,
        assignmentFilter: this.assignmentFilter,
        ContainerFilter: this.ContainerFilter,
        shiperInvFilter: "",
        InvoiceNoFilter: "",
        SBFilter: "",
        jobTypeFilter: this.jobTypeFilter,
        statusFilter: "",
        branchfilter: this.branchfilter,
        SOBFilter: this.SOBFilter,
        containerNoFilter: this.containerNoFilter,
        jobRecFilter: "",
        searchVal: this.filter,

        assignmentNo: "assignmentNo",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        shippingFilter: this.shippingFilter,
        PORfilter: this.PORfilter,
        PODfilter: this.PODfilter,
        LPfilter: this.LPfilter,
        selectedItems: this.selectedItems,
      };
      //console.log("Shreshth Gahlot => ", view_Assignment); return false
      this.ExcelBtnName = "Downloading Please Wait .....";
      CommonService.getAllMainReport(view_Assignment)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.excelName) {
              this.ExcelBtnName = "Download Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
              //`http://164.52.198.182/pridaldev-phase2/Pridel_Reports/` + data.excelName;
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on All_BL_List Error: ", error);
        });
    },
    // getReportsAss(id) {
    //   this.isLoading=true
    //   // alert(this.jobTypeFilter);
    //   // alert(id);
    //   let excelIdGivin = "";
    //   if (id == "MainAssignment_SCREEN") {
    //     excelIdGivin = "MainAssignment_SCREEN";
    //   }else if(id=="MainAssignment_SCREEN_ALL"){
    //     excelIdGivin = "MainAssignment_SCREEN_ALL";
    //   }
    //   let view_Assignment = {
    //     excelId: excelIdGivin,
    //     clientIdFilter: this.clientIdFilter,
    //     assignmentFilter: this.assignmentFilter,
    //     ContainerFilter: this.ContainerFilter,
    //     shiperInvFilter: '',
    //     InvoiceNoFilter: '',
    //     SBFilter: '',
    //     jobTypeFilter: this.jobTypeFilter,
    //     statusFilter:'',
    //     branchfilter: this.branchfilter,
    //     SOBFilter:this.SOBFilter,
    //     containerNoFilter:this.containerNoFilter,
    //     jobRecFilter: '',
    //     searchVal: this.filter,

    //     assignmentNo: "assignmentNo",
    //     fromDate: this.dateSearch.fromDate,
    //     toDate: this.dateSearch.toDate,
    //     dateRange: this.dateRange,
    //     shippingFilter:this.shippingFilter,
    //     PORfilter:this.PORfilter,
    //     PODfilter:this.PODfilter,
    //     LPfilter:this.LPfilter,
    //   };
    //   console.log(view_Assignment);
    //   let options = {
    //     method: "POST",
    //     // url: `${URL_BASE}/Api_Reports/reportsExcel_NewV3.php`,
    //     url: `${URL_BASE}/Api_MainReport/reportsMainExcel.php`,
    //     data: JSON.stringify(view_Assignment),
    //     crossDomain: true,

    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: this.$sessionsStorage.get("loginId"),
    //     },
    //   };

    //   axios(options)
    //     .then((result) => {
    //       const { statusText, status, data } = result;
    //       if ( status == 200 && data) {
    //         if (data.excelName != undefined) {
    //           window.location.href =
    //             `https://uploadsp.pridel.com/Pridel_Reports/` +
    //             data.excelName;
    //         }
    //         this.isLoading=false
    //       }
    //     })
    //     .catch((error) => {});
    // },

    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewFFExportFCL(CURRENT, "2", event);
    },
    proceedToManualInv() {
      this.$router.push({
        // path: "/allModuleForm/billing"
        path: "/allModuleForm/manualBill",
      });
    },
    filterSearch() {
      this.reload = false;
      this.viewFFExportFCL("0", "1", "1");
    },
    clearFilter() {
      this.clientIdFilter = "";
      this.jobTypeFilter = "";
      this.statusFilter = "";
      this.branchfilter = "";
      this.jobRecFilter = [];
      this.assignmentFilter = "";
      this.ContainerFilter = "";
      this.shiperInvFilter = "";
      this.InvoiceNoFilter = "";
      this.SBFilter = "";
      this.SOBFilter = "3";
      (this.containerNoFilter = ""),
        (this.dateRange = {
          startDate: "",
          endDate: "",
        }),
        (this.shippingFilter = "");
      this.PORfilter = "";
      this.PODfilter = "";
      this.LPfilter = "";
      this.viewFFExportFCL("0", "1", "1");
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewFFExportFCL(CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },

    JqueryFun() {
      return $(function () {
        return $("#conBooking").DataTable();
      });
    },

    viewExportFCLConPage(AM) {
      this.$sessionsStorage.set("editSalesExId", AM);

      this.$router.push({
        path: "/mainEnquiry/salesExecutionAll",
      });
    },
    viewFFExportFCL(CURRENT, SEARCH, pageNumber) {
      this.consoBooking = [];
      this.isLoading = true;
      let payload = {
        excelId: "",
        clientIdFilter: this.clientIdFilter,
        assignmentFilter: this.assignmentFilter,
        ContainerFilter: this.ContainerFilter,
        shiperInvFilter: this.shiperInvFilter,
        InvoiceNoFilter: this.InvoiceNoFilter,
        SBFilter: this.SBFilter,
        jobTypeFilter: this.jobTypeFilter,
        statusFilter: "",
        branchfilter: this.branchfilter,
        jobRecFilter: "",
        PORfilter: this.PORfilter,
        PODfilter: this.PODfilter,
        LPfilter: this.LPfilter,
        shippingFilter: this.shippingFilter,
        searchVal: this.filter,
        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        assignmentNo: "assignmentNo",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        SOBFilter: this.SOBFilter,
        containerNoFilter: this.containerNoFilter,
      };
      console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_MainReport/viewAllReport.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log("Report Data=>", data);
            this.totalRows = data.totalData;
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }
            if (data.assignmentData.length > 0) {
              this.consoBooking = data.assignmentData;
            } else {
              this.consoBooking = [];
            }
            if (this.reload == true) {
              if (data.clientMaster.length > 0) {
                this.clientMaster = data.clientMaster;
              }
              if (data.BranchDetailsFinal.length > 0) {
                this.branchList = data.BranchDetailsFinal;
              }

              if (data.LocationDetailsFinal.length > 0) {
                this.finalAllPlaceDataPOR = data.LocationDetailsFinal;
                this.finalAllPlaceDataPOD = data.LocationDetailsFinal;
                this.finalAllPlaceDataLP = data.LocationDetailsFinal;
              }
              if (data.shippingList.length > 0) {
                this.shippingList = data.shippingList;
              }
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    // onDragStart(index, section) {
    //   this.dragIndex = index;
    //   this.dragSection = section;
    // },
    // onDragOver() {
    //   alert(1);
    //   if (this.dragSection === 'available' && this.dragIndex !== null) {
    //     this.selectedColumns.push(this.availableColumns[this.dragIndex]);
    //     this.availableColumns.splice(this.dragIndex, 1);
    //   } else if (this.dragSection === 'selected' && this.dragIndex !== null) {
    //     this.availableColumns.push(this.selectedColumns[this.dragIndex]);
    //     this.selectedColumns.splice(this.dragIndex, 1);
    //   }
    //   this.dragIndex = null;
    //   this.dragSection = null;
    // },
  },
};
</script>
<style>
/* Style the container for checkboxes */
.checkbox-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

/* Style the checkbox itself */
.styled-checkbox {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  appearance: none;
  border: 2px solid #333;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
}

/* Style the checkbox when checked */
.styled-checkbox:checked {
  background-color: #002b49;
  border: 2px solid #002b49;
}

/* Style the label next to the checkbox */
label {
  padding-left: 5px;
} /*Drag And Drop CSS*/
.column-section {
  width: 100%;
  display: inline-block;
  vertical-align: top;
  margin-right: 20px;
}

.draggable {
  width: 48%;
  margin-right: 1%;
  float: left;
  cursor: grab;
  padding: 10px;
  border: 1px solid #ccc;
  margin-bottom: 5px;
}

.draggable:active {
  cursor: grabbing;
}
</style>



// WEBPACK FOOTER //
// viewReports.vue?74a700ad